import { render, staticRenderFns } from "./approveRecord.vue?vue&type=template&id=86de4f14&scoped=true&"
import script from "./approveRecord.vue?vue&type=script&lang=js&"
export * from "./approveRecord.vue?vue&type=script&lang=js&"
import style0 from "./approveRecord.vue?vue&type=style&index=0&id=86de4f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86de4f14",
  null
  
)

export default component.exports